import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import UserContext from './UserContext';
import { toast } from 'react-toastify';

/**
 * Route guard component that redirects based on service partner type
 * @param {Object} props
 * @param {string} props.allowedType - 'instructor' | 'consultant' - which partner type can access this route
 * @param {string} props.redirectTo - where to redirect if access denied
 * @param {React.ReactNode} props.children - child components to render if access allowed
 */
function ServiceRouteGuard({ allowedType, redirectTo, children }) {
  const navigate = useNavigate();
  const { session: trainer } = useContext(UserContext);

  useEffect(() => {
    if (!trainer || !trainer.isTrainer || trainer.trainerStatus !== 'active') {
      // Not a trainer, let Guard component handle it
      return;
    }

    const trainerServices = (trainer.services && trainer.services.length > 0) ? trainer.services : (trainer.service ? [trainer.service] : []);
    const servicePartnerTypes = trainer.servicePartnerTypes || {};
    
    // Get active service from localStorage
    const activeService = localStorage.getItem('activeService') || trainerServices[0];
    
    if (!activeService) {
      // No service selected, redirect to home
      navigate('/trainer/home');
      return;
    }

    const activePartnerType = servicePartnerTypes[activeService] || 'instructor';

    // Check if current service's partner type matches allowed type
    if (activePartnerType !== allowedType) {
      toast.error(`This page is only accessible for ${allowedType} services. Your current service (${activeService}) is configured as ${activePartnerType}.`);
      navigate(redirectTo || '/trainer/home');
    }
  }, [trainer, allowedType, redirectTo, navigate]);

  // If we get here and trainer exists, render children
  if (!trainer || !trainer.isTrainer || trainer.trainerStatus !== 'active') {
    return null; // Let Guard component handle authentication
  }

  const trainerServices = (trainer.services && trainer.services.length > 0) ? trainer.services : (trainer.service ? [trainer.service] : []);
  const servicePartnerTypes = trainer.servicePartnerTypes || {};
  const activeService = localStorage.getItem('activeService') || trainerServices[0];
  const activePartnerType = activeService ? (servicePartnerTypes[activeService] || 'instructor') : 'instructor';

  // Only render if access is allowed
  if (activePartnerType === allowedType) {
    return children;
  }

  return null;
}

export default ServiceRouteGuard;


